export default __webpack_public_path__ + "static/media/test-summary-photo.f9385583.jpg";